var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimatedLearning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 50,
    width: 200,
    height: 300,
    rx: 20,
    ry: 20,
    fill: "#333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 70,
    width: 180,
    height: 250,
    rx: 5,
    ry: 5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 330,
    r: 10,
    fill: "#666"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 90,
    width: 140,
    height: 30,
    rx: 5,
    ry: 5,
    fill: "#ff6b00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 130,
    width: 140,
    height: 10,
    rx: 2,
    ry: 2,
    fill: "#ddd"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 150,
    width: 120,
    height: 10,
    rx: 2,
    ry: 2,
    fill: "#ddd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 170,
    width: 130,
    height: 10,
    rx: 2,
    ry: 2,
    fill: "#ddd"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 200,
    width: 60,
    height: 60,
    rx: 5,
    ry: 5,
    fill: "#f0f4f8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 200,
    width: 60,
    height: 60,
    rx: 5,
    ry: 5,
    fill: "#f0f4f8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 270,
    width: 130,
    height: 30,
    rx: 5,
    ry: 5,
    fill: "#ff6b00",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedLearning);
export default __webpack_public_path__ + "static/media/animated-learning.d114846571959a7e35bfad27c85da964.svg";
export { ForwardRef as ReactComponent };